import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  private readonly _isEnabled = signal(true);
  public readonly isEnabled = this._isEnabled.asReadonly();

  public trackPageViews(): void {
    // TODO move setEnabled: the user must be activate / deactivate this functionality
    this.setEnabled(true);

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(async (event: NavigationEnd) => {
        if (this.isEnabled()) {
          await this.logPageView(event.urlAfterRedirects);
        }
      });
  }

  public async setEnabled(enabled: boolean): Promise<void> {
    try {
      await FirebaseAnalytics.setEnabled({ enabled });
      this._isEnabled.set(enabled);
      console.log('Analytics', enabled ? 'enabled' : 'disabled');
    } catch (error) {
      console.error('Error setting analytics enabled state:', error);
    }
  }

  private async logPageView(pageName: string, params?: Record<string, any>): Promise<void> {
    if (!this.isEnabled()) {
      return;
    }

    try {
      await FirebaseAnalytics.logEvent({
        name: 'screen_view',
        params: {
          screen_name: pageName,
          screen_class: pageName,
          ...params,
        },
      });
    } catch (error) {
      console.error('Error logging page view:', error);
    }
  }

  public async logEvent(name: string, params?: Record<string, any>): Promise<void> {
    if (!this.isEnabled()) {
      console.log('Analytics disabled, event not logged:', name);
      return;
    }

    try {
      await FirebaseAnalytics.logEvent({
        name,
        params: params || {},
      });
      console.log('Event logged:', name, params);
    } catch (error) {
      console.error('Error logging event:', error);
    }
  }

  // TODO add: setUserId(), clearUserId(),setUserProperty(), clearUserProperty(), clearAllUserProperties(), getCurrentUserId(),...
}
